import AnalyticsTable from "./analytics-table";

export default AnalyticsTable;